import { Button, Modal } from "react-bootstrap";
import { ICaseResolutionPlanStepModel } from "../../../../interfaces/ICaseResolutionModel"


interface CaseResolutionSubmitModalProps {
    caseResolutionStep: ICaseResolutionPlanStepModel;
    onHide: () => void;
    onContinue: () => void;
    open: boolean;
}

export function CaseResolutionSubmitModal({
    caseResolutionStep,
    onHide,
    onContinue,
    open
}: CaseResolutionSubmitModalProps) {


    const handleContinue = () => {
        onContinue();
    }

    const handleCancel = () => {
        onHide();
    }

    return (
        <Modal
            centered
            show={open}
            dialogClassName="official-case-doc-dialog"
            size="lg"
            onHide={onHide}
            backdrop={false}
        >
            <Modal.Header>
                <Modal.Title>Submit Draft</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group mb-2">
                    This action cannot be undone.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleContinue}>
                    Continue
                </Button>
                <button className="btn btn-default" onClick={handleCancel}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    )
}